import { Stream } from '@/types/commons/commons.types';

import {
  AlertTimeoutThreshold,
  CommonConfiguration,
  CommonSensorStatus,
  PortConfiguration,
  RemoteHostConfiguration,
  SensorTypeEnum,
} from './common.types';

export enum ModuleTypeEnum {
  VIDEO = 'VIDEO',
  JAMMING = 'JAMMING',
}

interface AbstractSensorModule {
  id: number | null;
  code: string;
  name: string;
  componentId: number;
}

export enum JamTypeEnum {
  GPS_L1 = 'GPS_L1',
  WIFI_2_4 = 'WIFI_2_4',
  WIFI_5_8 = 'WIFI_5_8',
}

export interface JammingModule extends AbstractSensorModule {
  moduleType: ModuleTypeEnum.JAMMING;
  range: number;
  aperture: number;
  jammingTypes: JamTypeEnum[];
}

export interface VideoModule extends AbstractSensorModule, Stream {
  moduleType: ModuleTypeEnum.VIDEO;
}

export type GCSDroneModule = JammingModule | VideoModule;

export interface GroundStationDrone {
  id: number | null;
  code: string;
  name: string;
  systemId: number;
  canControl: boolean;
  useRawPosition: boolean;
  modules: GCSDroneModule[];
}

export enum MavlinkReferentialEnum {
  LAT_LNG_ALT_HOME = 'LAT_LNG_ALT_HOME',
  LAT_LNG_ALT_GROUND = 'LAT_LNG_ALT_GROUND',
}

export interface GroundStationSensorConfiguration
  extends CommonConfiguration, PortConfiguration, RemoteHostConfiguration, AlertTimeoutThreshold {
  type: SensorTypeEnum.GROUND_STATION;
  manualRemoteConfiguration: boolean;
  referential: MavlinkReferentialEnum;
  drones: GroundStationDrone[];
}

export interface GroundStationSensorStatus extends CommonSensorStatus {
  type: SensorTypeEnum.GROUND_STATION;
}
